import { render, staticRenderFns } from "./ProblemDisplay.vue?vue&type=template&id=ec55ed58&scoped=true&"
import script from "./ProblemDisplay.vue?vue&type=script&lang=js&"
export * from "./ProblemDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProblemDisplay.vue?vue&type=style&index=0&id=ec55ed58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec55ed58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VRow,VSheet})
